import { useEffect } from 'react';
import PropTypes from 'prop-types';
import SelectInvoice from 'Components/Organisms/SelectInvoice/SelectInvoice';
import { useFormContext, Controller } from 'react-hook-form';

export default function RHFSelectInvoice({ name, onChange, ...other }) {
    const { control, clearErrors } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                const handleChange = (invoiceId, invoice) => {
                    if (onChange) {
                        onChange(invoiceId, invoice);
                    }
                    field.onChange(invoiceId);
                };

                useEffect(() => {
                    if (field.value && error) {
                        clearErrors(name);
                    }
                }, [name, field.value, clearErrors]);

                return <SelectInvoice {...field} error={error?.message} {...other} onChange={handleChange} />;
            }}
        />
    );
}

RHFSelectInvoice.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};
